<template>
    <div class="vote" v-loading='proloading'>
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="疾病：">
                        <el-cascader v-model="lb_value" size="small" :props="lb_props" :options="lb_options">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="人员：">
                        <el-select v-model="search_ry" clearable placeholder="请选择" size="small" filterable>
                            <el-option v-for="item in  ry_options" :key="item.id" :label="item.nickname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间：">
                        <el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="类型：">
                        <el-select v-model="type" placeholder="请选择" size="small">
                            <el-option :value="1" label="文章">文章</el-option>
                            <el-option :value="2" label="视频">视频</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型：">
                        <el-input v-model="keyword" size="small" placeholder="请输入内容"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <el-table :data="tw_tableData" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="create_author_text" label="创作人" width="120">
                <template slot-scope="scope">
                    <span>{{scope.row.author_text}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="content" label="封面" width="80">
                <template slot-scope="scope">
                    <div class="u-f u-wrap" v-if="scope.row.cover_map">
                        <div v-for="(item,index) in scope.row.cover_map" :key="index">
                            <el-image style="width: 50px; height: 50px" :src="item.url" :preview-src-list="[item.url]"
                                :z-index='100000'>
                            </el-image>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="描述" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip width="180"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="success" @click="handleSelect(scope.row,scope.$index)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="u-f u-ac u-jsb ft_mr">
            <div></div>
            <div>
                <el-pagination @size-change="handleSizeChange_tw" @current-change="handleCurrentChange_tw"
                    :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                lb_value: '',
                lb_options: [],
                lb_props: {
                    label: "name",
                    value: "id",
                    children: 'child'
                },
                search_ry: '',
                ry_options: [],
                times: [],
                type: 1,
                keyword: '',
                tw_tableData: [],
                count: 0,
                pagesize: 15,
                currentPage: 1,
                loading: false,
                height: null,
                eid: '',
                proloading: false,
            }
        },
        mounted() {
            this.getHeight()
            this.getlbxx()
            this.getper()
            this.begin()

        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 255 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 255 + 'px'
                }
            },
            // 类别
            getlbxx() {
                let that = this
                axios
                    .post("/admin/healthCategory/categoryHead", {
                        noChild: 1
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.lb_options = response.data.data
                    })
                    .catch(error => {})
            },
            // 获取人员
            getper() {
                let that = this
                axios
                    .post(`/admin/doctorAssistantList`, {}, {
                        token: true
                    })
                    .then(response => {
                        that.ry_options = response.data.data
                    })
                    .catch(error => {})
            },
            begin() {
                this.currentPage=1
                this.getlist()
            },
            getlist() {
                this.tw_tableData = []
                this.proloading = true
                axios
                    .post("/admin/pc/health/healthList", {
                        page: this.currentPage,
                        page_count: this.pagesize,
                        health_category_id: this.lb_value[this.lb_value.length - 1],
                        type: this.type,
                        start_time: this.times ? this.times[0] : '',
                        end_time: this.times ? this.times[1] : '',
                        user_id: this.search_ry,
                        keyword: this.keyword,

                    }, {
                        token: true
                    })
                    .then(res => {
                        this.proloading = false
                        if (res.data.code == '200') {
                            this.tw_tableData = res.data.data.list
                            this.count = res.data.data.totalCount
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            handleSizeChange_tw(val) {
                let that = this
                that.pagesize = val;
                that.getlist()
            },
            handleCurrentChange_tw(val) {
                let that = this
                that.currentPage = val;
                that.getlist()
            },
            handleSelect(row, index) {
                let that = this
                let obj={
                    name:row.name,
                    id:row.id
                }
                that.$emit('selecttuwen',obj)
            },
        },
        watch: {

        }
    }
</script>

<style lang="scss" scoped>
    .add_tits {
        padding: 0 10px;
    }
</style>